module.exports = __webpack_public_path__ + "img/poster-post-item-bg.e15a3d2c.png";